import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import api, { getApiErrorMessage } from '../../services/api';
import { toast } from 'react-toastify';
import PublicSEO from '../../components/public/PublicSEO';
import './AuthPublic.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmedEmail = (email || '').trim();
    if (!trimmedEmail) {
      setError('Inserisci l\'indirizzo email.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: trimmedEmail });
      setSent(true);
      toast.success('Se l\'email è registrata, riceverai il link per reimpostare la password.');
    } catch (err) {
      setError(getApiErrorMessage(err, 'Errore durante l\'invio. Riprova o contatta l\'assistenza.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vc-auth">
      <PublicSEO
        title="Password dimenticata"
        description="Recupera la password del tuo account Virtual Clinic."
        canonicalPath="/forgot-password"
        noIndex
      />
      <div className="vc-auth__card">
        <h1 className="vc-auth__title">Password dimenticata</h1>
        <p className="vc-auth__lead">
          Inserisci l&apos;email con cui ti sei registrato. Ti invieremo un link per reimpostare la password.
        </p>

        {sent ? (
          <div className="vc-auth__error" style={{ background: '#e3f1ee', color: '#1f5f55' }} role="status">
            Controlla la casella email. Se l&apos;indirizzo è registrato, riceverai le istruzioni.
            Controlla anche lo spam.
          </div>
        ) : (
          <>
            {error && <div className="vc-auth__error" role="alert">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="vc-auth__field">
                <label htmlFor="vc-forgot-email">Email</label>
                <div className="vc-auth__input-wrap">
                  <span className="vc-auth__icon" aria-hidden="true"><Icon icon="mage:email" /></span>
                  <input
                    id="vc-forgot-email"
                    type="email"
                    className="vc-auth__input"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <button type="submit" className="vc-btn vc-btn-primary vc-auth__submit" disabled={loading}>
                {loading ? 'Invio in corso…' : 'Invia link'}
              </button>
            </form>
          </>
        )}

        <p className="vc-auth__footer">
          <Link to="/login" className="vc-auth__link">Torna al login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
